import { SvgIcon } from '@material-ui/core'

export default function LightbulbIcon(props: any) {
    return (
        <SvgIcon width="24" height="24" viewBox="0 0 24 24" fill="none" {...props}>
            <path
                d="M4.5 9.76594C4.5 5.73718 7.87403 2.5 12 2.5C16.126 2.5 19.5 5.73718 19.5 9.76594C19.5 12.1199 18.5269 14.2437 16.7051 15.5831C16.5794 15.6756 16.5033 15.7902 16.4767 15.9028C16.423 16.1308 16.3641 16.3918 16.3035 16.6718C16.2735 16.8103 16.1512 16.9095 16.0095 16.9095H7.99054C7.8488 16.9095 7.72649 16.8103 7.6965 16.6718C7.63588 16.3918 7.57696 16.1308 7.52325 15.9028C7.49675 15.7902 7.42064 15.6756 7.2949 15.5831C5.47313 14.2437 4.5 12.1199 4.5 9.76594Z"
                fill="currentColor"
            />
            <path
                d="M8.40053 18.4095C8.21367 18.4095 8.07242 18.5786 8.10352 18.7629C8.19745 19.3194 8.26604 19.8165 8.28682 20.1599C8.34981 21.2011 9.11672 22.0588 10.1422 22.2803L10.3382 22.3227C11.4326 22.5591 12.5674 22.5591 13.6618 22.3227L13.8578 22.2803C14.8833 22.0588 15.6502 21.2011 15.7132 20.1599C15.734 19.8165 15.8026 19.3194 15.8965 18.7629C15.9276 18.5786 15.7863 18.4095 15.5995 18.4095H8.40053Z"
                fill="currentColor"
            />
        </SvgIcon>
    )
}
